import { useState } from "react";
import SectionHeader from "./SectionHeader";

const faqs = [
  {
    q: "吹雪漫画网的追更进度是怎么记录的？",
    a: "当你收藏一部连载中或完结的漫画后，系统会自动记录你阅读到的最新话数，并用进度条直观展示这部作品的整体追更进度。下次回来，会直接跳回你上次读到的位置，续看不迷路。",
  },
  {
    q: "最新话更新后如何第一时间知道？",
    a: "打开作品的更新提醒功能即可。新章节上线后，更新状态会实时同步，连载进度条同步推进，同时你还能在“今日最新更新”栏目里看到近期的更新动态，热门连载的新话一个都不会漏。",
  },
  {
    q: "完结漫画和连载中的作品有什么区别？",
    a: "连载中的作品会持续更新最新话，进度条随更新不断推进；完结漫画则已完整完结，标注完整话数与 100% 完结进度，适合想一口气读完的读者直接翻找，随时开看。",
  },
  {
    q: "我收藏的作品在哪里查看？",
    a: "收藏成功后，作品会进入你的个人追更清单，连载与完结的分类一目了然。清单里会同步显示每部作品的追更进度、最新话数与更新状态，方便集中管理。",
  },
  {
    q: "在手机和电脑上都能正常使用吗？",
    a: "可以。吹雪漫画网采用响应式设计，无论你用手机、平板还是电脑浏览，页面都会自动适配屏幕，搜索、收藏、追更进度和更新提醒等功能在所有设备上都能正常使用。",
  },
  {
    q: "漫画信息多久更新一次？",
    a: "连载中的作品会在最新话上线后第一时间同步最新话与进度，今日更新栏目也会持续刷新。你关心的每一部作品，进度都会保持最新，点开即知、追更不断档。",
  },
];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-12 md:py-16">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionHeader
          tag="读前答疑"
          title="常见问题"
          desc="关于追更进度、更新提醒与完结漫画的疑问，这里都为你解答。"
          align="center"
        />

        <div className="space-y-3">
          {faqs.map((faq, i) => {
            const open = openIndex === i;
            return (
              <div
                key={faq.q}
                className={`overflow-hidden rounded-lg ring-1 transition ${
                  open ? "bg-primary-50 ring-primary-200" : "bg-background-100 ring-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <h3 className="text-sm font-medium text-foreground-950 md:text-base">{faq.q}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${
                      open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={`text-sm ${open ? "ri-subtract-line" : "ri-add-line"}`}></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}